module.exports = __webpack_public_path__ + "static/img/brees-2017-slide-1.1e0b35e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2017-slide-1.jpg
// module id = HYJn
// module chunks = 1